import React from 'react';
import { styled } from '@compiled/react';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';
import { useBacklogSelector } from '../../../../../state';
import { getCardColor } from '../../../../../state/selectors/cards';

type Props = {
	id: number;
};

export function CardColor({ id }: Props) {
	const color = useBacklogSelector((state) => getCardColor(state, id));

	if (!color) {
		return null;
	}

	return <Container role="presentation" color={color} />;
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div<{ color: string }>({
	position: 'absolute',
	top: 0,
	left: 0,
	bottom: 0,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize / 2}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	backgroundColor: ({ color }) => color,
});
